/**
 * @license lucide v0.577.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

const ListX = [
  ["path", { d: "M16 5H3" }],
  ["path", { d: "M11 12H3" }],
  ["path", { d: "M16 19H3" }],
  ["path", { d: "m15.5 9.5 5 5" }],
  ["path", { d: "m20.5 9.5-5 5" }]
];

export { ListX as default };
//# sourceMappingURL=list-x.js.map
